// extracted by mini-css-extract-plugin
export var container = "Card-module--container--15bzJ";
export var largeCard = "Card-module--largeCard--2jEDb";
export var card = "Card-module--card--3D-98";
export var white = "Card-module--white--17vvp";
export var spacer = "Card-module--spacer--21gQw";
export var text = "Card-module--text--1wPBt";
export var title = "Card-module--title--1DOJu";
export var subtitle = "Card-module--subtitle--plqCF";
export var content = "Card-module--content--31OXJ";
export var grower = "Card-module--grower--3VZuH";